<div class="container">
  <h1>Performance Analytics</h1>
  
  <div *ngIf="isLoading" class="loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p>Loading performance data...</p>
  </div>

  <div class="grid" *ngIf="!isLoading">
    <mat-card *ngFor="let item of data" class="perf-card">
      <mat-card-header>
        <mat-card-title [matTooltip]="item.name">{{ getCardTitle(item.name) }}</mat-card-title>
        <mat-card-subtitle>{{ item.count }} events recorded</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="stats">
          <div class="stat">
            <span class="label">Avg</span>
            <span class="value">{{ item.avg | number:'1.0-2' }}ms</span>
          </div>
          <div class="stat">
            <span class="label">Median</span>
            <span class="value">{{ item.median | number:'1.0-2' }}ms</span>
          </div>
          <div class="stat">
            <span class="label">Min</span>
            <span class="value">{{ item.min | number:'1.0-2' }}ms</span>
          </div>
          <div class="stat">
            <span class="label">Max</span>
            <span class="value">{{ item.max | number:'1.0-2' }}ms</span>
          </div>
        </div>

        <div class="chart">
          <div class="bar-container" 
               *ngFor="let count of item.buckets; let i = index"
               [matTooltip]="count + ' events\n' + getBucketLabel(i, item.bucketSize, item.min)">
            <div class="bar" [style.height.%]="getBucketHeight(count, item.buckets)"></div>
          </div>
        </div>
        <div class="chart-labels">
          <span>{{ item.min | number:'1.0-0' }}ms</span>
          <span>{{ item.max | number:'1.0-0' }}ms</span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  
  <div *ngIf="!isLoading && data.length === 0" class="empty-state">
    <mat-icon>analytics</mat-icon>
    <p>No performance data collected yet.</p>
  </div>
</div>

